var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorksImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189.689,
    height: 169.803,
    viewBox: "0 0 189.689 169.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2982",
    "data-name": "Rectangle 2982",
    width: 189.689,
    height: 169.803,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22457",
    "data-name": "Group 22457",
    transform: "translate(-296 -987.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22233",
    "data-name": "Path 22233",
    d: "M13,0H176a31.489,31.489,0,0,1,13,15.234l0,81.551v13.348L0,109.392V96.785L1.443,13.2C3.59,8.217,7.422,4.845,13,0Z",
    transform: "translate(296 989)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22220",
    "data-name": "Path 22220",
    d: "M5,0c2.761,0,5,5.6,5,12.5s.809,12.489-1.691,12.489c-1.258,0-6.347,2.533-8.309,0C-1.56,22.983,0,15.931,0,12.5,0,5.6,2.239,0,5,0Z",
    transform: "translate(369 1006)",
    fill: "#dd2228",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22221",
    "data-name": "Path 22221",
    d: "M5,0c2.761,0,5,5.6,5,12.5s.809,12.489-1.691,12.489c-1.258,0-6.347,2.533-8.309,0C-1.56,22.983,0,15.931,0,12.5,0,5.6,2.239,0,5,0Z",
    transform: "translate(403 1006)",
    fill: "#dd2228",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22456",
    "data-name": "Group 22456",
    transform: "translate(296 987.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22455",
    "data-name": "Group 22455",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22210",
    "data-name": "Path 22210",
    d: "M170.68,0H19.009A19.03,19.03,0,0,0,0,19.008v82.71a1.976,1.976,0,1,0,3.952,0V19.008A15.073,15.073,0,0,1,19.01,3.952H170.681a15.073,15.073,0,0,1,15.057,15.057v82.71a1.976,1.976,0,1,0,3.952,0V19.008A19.03,19.03,0,0,0,170.68,0Z",
    transform: "translate(-0.001)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22211",
    "data-name": "Path 22211",
    d: "M425.544,291.15a1.976,1.976,0,1,0,0-3.952H412.326a1.976,1.976,0,0,0,0,3.952Z",
    transform: "translate(-256.545 -179.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22212",
    "data-name": "Path 22212",
    d: "M187.712,287.2H178.5a1.976,1.976,0,1,0,0,3.952h7.232v13.357a15.073,15.073,0,0,1-15.057,15.057H19.009A15.073,15.073,0,0,1,3.952,304.508V291.151h131a1.976,1.976,0,0,0,0-3.952H1.976A1.976,1.976,0,0,0,0,289.175v15.333a19.03,19.03,0,0,0,19.008,19.008h58.77L64.21,345.4h-13.2a1.976,1.976,0,1,0,0,3.952h87.686a1.976,1.976,0,1,0,0-3.952h-13.2l-13.567-21.887h58.756a19.03,19.03,0,0,0,19.008-19.008V289.175A1.974,1.974,0,0,0,187.712,287.2Zm-66.868,58.2H68.861l13.568-21.887h24.848Z",
    transform: "translate(0 -179.553)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22213",
    "data-name": "Path 22213",
    d: "M289.291,330.371a1.976,1.976,0,0,0,0,3.952h1.825a1.976,1.976,0,0,0,0-3.952Z",
    transform: "translate(-179.625 -206.543)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22214",
    "data-name": "Path 22214",
    d: "M247.334,330.371a1.976,1.976,0,1,0,0,3.952h1.825a1.976,1.976,0,1,0,0-3.952Z",
    transform: "translate(-153.394 -206.543)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22215",
    "data-name": "Path 22215",
    d: "M205.374,330.371a1.976,1.976,0,1,0,0,3.952H207.2a1.976,1.976,0,1,0,0-3.952Z",
    transform: "translate(-127.161 -206.543)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22216",
    "data-name": "Path 22216",
    d: "M204.13,190.95A1.975,1.975,0,0,0,206,192.279a2,2,0,0,0,.647-.108,1.978,1.978,0,0,0,1.22-2.514l-5.641-16.272a1.976,1.976,0,1,0-3.734,1.293Z",
    transform: "translate(-124.024 -107.566)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22217",
    "data-name": "Path 22217",
    d: "M249.769,192.279a1.975,1.975,0,0,0,1.976-1.976V174.031a1.976,1.976,0,1,0-3.952,0V190.3a1.975,1.975,0,0,0,1.976,1.976",
    transform: "translate(-154.916 -107.566)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22218",
    "data-name": "Path 22218",
    d: "M283.481,192.166a1.942,1.942,0,0,0,.647.11,1.972,1.972,0,0,0,1.866-1.329l5.642-16.272a1.975,1.975,0,0,0-3.732-1.293l-5.642,16.272a1.972,1.972,0,0,0,1.22,2.512",
    transform: "translate(-176.397 -107.562)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22219",
    "data-name": "Path 22219",
    d: "M156.6,43.939a7.358,7.358,0,0,0-7.349,7.35v18.3H133.539a7.943,7.943,0,0,0-.24,15.884l9.7,29.808a10.561,10.561,0,0,0,10.068,7.309h40.595a10.566,10.566,0,0,0,10.069-7.309l9.7-29.808a7.943,7.943,0,0,0-.243-15.883H197.478v-18.3a7.35,7.35,0,0,0-14.7,0v18.3H163.952v-18.3A7.357,7.357,0,0,0,156.6,43.939Zm-3.4,7.35a3.4,3.4,0,1,1,6.794,0v18.3h-6.794v-18.3Zm46.768,62.772a6.62,6.62,0,0,1-6.31,4.581h-40.6a6.621,6.621,0,0,1-6.311-4.581l-9.3-28.56h71.811ZM217.2,77.547a4.006,4.006,0,0,1-4,4H133.539a4,4,0,0,1,0-8c16.623,0,38.808.025,79.655,0a4.006,4.006,0,0,1,4,4M186.731,51.289a3.4,3.4,0,1,1,6.8,0v18.3h-6.8Z",
    transform: "translate(-78.514 -27.47)",
    fill: "#212121"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksImg2);
export default __webpack_public_path__ + "static/media/how-it-works-img-2.6dafeaeb5f41070ac332fc25e1e5c65b.svg";
export { ForwardRef as ReactComponent };